





























































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "./Loading.vue";
import ShowMoreView from "../controls/ShowMoreView.vue";
import PointerMenu from "../general/PointerMenu.vue";
import SettingsMaterialItemForm from "../settings/SettingsMaterialItemForm.vue";

import MaterialItemJson from "../../shared/MaterialItemJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateItemImageJson, validateItemImageJsonAdd } from "../../shared/ItemImageJson";

export default Vue.extend({
  name: "MaterialItemInput",
  components: {
    Loading,
    ShowMoreView,
    PointerMenu,
    SettingsMaterialItemForm,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Array as PropType<MaterialItemJson[]>,
    editable: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      allMaterialItems: null as MaterialItemJson[] | null,
      details: null as MaterialItemJson[] | null,
      showMaterialItemDetails: false as boolean,
      selectedMaterialItemId: null as number | null,
      detailsMode: "read",
      materialItemToAdd: null as MaterialItemJson | null,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    toggleMaterialItemDetails() {
      (this.$refs["showmore-materialItemDetails"] as any).toggleExpandable();
      this.showMaterialItemDetails = !this.showMaterialItemDetails;
      if (this.showMaterialItemDetails == false) {
        this.loadMaterialItems();
      }
    },

    openMaterialItemDetails(item: MaterialItemJson | null, mode: string) {
      if (item != null) {
        this.selectedMaterialItemId = item.ID;
      } else {
        this.selectedMaterialItemId = null;
      }

      this.detailsMode = mode;
      this.toggleMaterialItemDetails();
    },
    /*** END: details view ***/

    init() {
      this.details = this.data;

      this.loadMaterialItems();
    },

    async loadMaterialItems() {
      if (this.restClient != null) {
        this.allMaterialItems = null;

        try {
          this.allMaterialItems = await this.restClient.getMaterialItems();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    addMaterialItem() {
      if (this.materialItemToAdd != null) {
        if (this.details == null) this.details = [];
        this.details.push(this.materialItemToAdd);

        this.materialItemToAdd = null;
      }
    },

    removeMaterialItem(index: number) {
      if (this.details != null) {
        this.details.splice(index, 1);

        if (this.details.length <= 0) this.details = null;
      }
    },

    //START set cached data

    //END set cached data

    //START set input data (where data be cached)

    //END set input data (where data be cached)
  },

  watch: {
    details: {
      handler() {
        this.$emit("change", this.details);
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
